import {classNames} from '@shopify/css-utilities';
import {forwardRef} from 'preact/compat';

import {Button} from './Button';
import type {ButtonProps} from './Button';

interface BrandedButtonProps extends ButtonProps {
  fullWidth?: boolean;
}

export const BrandedButton = forwardRef<HTMLButtonElement, BrandedButtonProps>(
  ({children, fullWidth, ...props}, ref) => {
    return (
      <Button
        {...props}
        className={classNames(
          'm-auto',
          fullWidth ? 'w-full justify-center' : undefined,
        )}
        ref={ref}
      >
        <span className="mx-auto flex cursor-pointer items-center justify-center gap-1 whitespace-nowrap p-shop-button font-sans text-branded-button text-white">
          {children}
        </span>
      </Button>
    );
  },
);

BrandedButton.displayName = 'BrandedButton';
